import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={33} height={32} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M21.428 13a1 1 0 110 2h-14a1 1 0 110-2h14zM25.428 9a1 1 0 010 2h-18a1 1 0 110-2h18zM25.428 17a1 1 0 010 2h-18a1 1 0 110-2h18zM16.23 21a1 1 0 010 2H7.428a1 1 0 110-2h8.802z" fill="#000" /></svg>;
}
export default SvgComponent;